import { MODULE_NAME } from './constants'

export const ADD_ITEM_TO_LIST = `${MODULE_NAME}/ADD_ITEM_TO_LIST`
export const UPDATE_ITEM_IN_LIST = `${MODULE_NAME}/UPDATE_ITEM_IN_LIST`

export const STATUS_SET_ITEM = `${MODULE_NAME}/STATUS_SET_ITEM`
